import { getResourceQueries } from './utils';
import { getListVariables } from '../getListVariables';
import { useGetInputList } from './getInputList';
import { useGraphQLRequest } from 'providers/graphqlPermissions';

export const useGetList = () => {
  const getInputList = useGetInputList();
  const { gqlRequest } = useGraphQLRequest();

  return async (resource, params) => {
    const {
      pagination: { page, perPage },
      sort: { field, order },
      filter,
    } = params;

    if ('_input' in filter) {
      return getInputList(resource, params);
    }

    const queries = getResourceQueries(resource);
    const listQuery = queries.list.query;
    const variables = getListVariables({
      type: 'GET_LIST',
      resource,
      params: { pagination: { page, perPage }, sort: { field, order }, filter },
    } as any);

    const response = await gqlRequest({
      fetchPolicy: 'network-only',
      query: listQuery,
      variables,
    });

    const data = response.data[queries.list.name];
    const metaData = response.data[queries.list.metaName];
    return {
      data,
      total: metaData ? metaData.count : data.length,
    };
  };
}
